import React from 'react';
import ReactDOM from 'react-dom';
//import './index.css';
//import App from './App';
//import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import Routes from './routes/routes';
import config from '../src/configs/config';
import { Provider } from 'react-redux'
import { store } from './app/store'

if(window.location.hostname === 'localhost') config.basename = '/';

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename={config.basename}>
      <Routes />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
